import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import type { OrganizationProfile } from "../../client";
import type { QueryConfig } from "../utils/query-config";
import { getV1OrganizationsByOrganizationIdProfilesOptions } from "../../client/@tanstack/react-query.gen";

export const organizationProfilesQueryOptions = (organizationId: string) => {
  return queryOptions({
    ...getV1OrganizationsByOrganizationIdProfilesOptions({
      path: { organizationID: organizationId },
    }),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useGetOrganizationProfiles = (
  organizationId: string,
  config?: QueryConfig, // Add optional config for enabling/disabling
) => {
  return useSuspenseQuery({
    ...organizationProfilesQueryOptions(organizationId),
    ...config, // Merges additional configuration, including `enabled`
  });
};
